import React, { useEffect, useRef, useState } from "react";
import { TextField, InputLabel, MenuItem } from "@mui/material";
import { TbPhotoPlus } from "react-icons/tb";
import { FaAngleLeft } from "react-icons/fa";
import { Button, message } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  post_sub_category,
  subcategoryImagePost,
  updateImages,
  validateSlugUrl,
} from "../../../redux/Subcategory/SubcategorySlice";

const AddSubcategory = () => {
  const dispatch = useDispatch();
  const { mobileImage, desktopImage } = useSelector(
    (store) => store.subcategory
  );
  const { category_all } = useSelector((store) => store.category);

  const [categoryName, setCategoryName] = useState("");
  const [subcategoryName, setsubCategoryName] = useState("");
  const [subcategoryUrl, setsubCategoryUrl] = useState("");
  const [subcategoryError, setsubCategoryError] = useState("");
  const [button_press, setButton_press] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (button_press === true) {
      if (subcategoryUrl === "") {
        setsubCategoryError("Enter name");
      }
    }
  }, [button_press, subcategoryUrl]);

  const check_subcategory_url = async (e) => {
    const value = e.target.value;
    setsubCategoryName(value);
    setsubCategoryError("");
    if (value) {
      const url = value
        .trim()
        .toLowerCase()
        .replace(" ", "-")
        .replace(/[.*+&?^ $@#%^!'{}()|[\]\\]/g, "-")
        .replace("--", "-")
        .replace("---", "-")
        .replace("----", "-")
        .replace("/", "-")
        .replace("//", "-")
        .replace("///", "-");

      const verify = await dispatch(validateSlugUrl(url));
      if (verify.payload.success === false) {
        setsubCategoryUrl(url);
        setsubCategoryError("");
      } else {
        setsubCategoryUrl("");
        setsubCategoryError(verify.payload.message);
      }
    }
  };

  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const files = Array.from(e.target.files);
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = async () => {
          if (reader.readyState === 2) {
            const get_img = await dispatch(
              subcategoryImagePost({ desktopImage: reader.result })
            );
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  const submitPress = async () => {
    setButton_press(true);
    if (subcategoryUrl === "") {
      setsubCategoryError("Enter name");
    }
    if (categoryName !== "" && subcategoryUrl !== "" && desktopImage !== "") {
      const find_cat = category_all.find((data) => data.name === categoryName);

      const formdata = {
        name: subcategoryName,
        slugUrl: `${subcategoryUrl}-${find_cat.slugUrl}`,
        category: find_cat.name,
        categoryUrl: find_cat.slugUrl,
        mobileImage: mobileImage,
        desktopImage: desktopImage,
      };

      const form_posting = await dispatch(post_sub_category(formdata));
      if (form_posting.payload.success === true) {
        messageApi.open({
          type: "success",
          content: `Sub-Category add Successfully`,
        });
        const formdata = {
          mobileImage: "",
          desktopImage: "",
        };
        dispatch(updateImages(formdata));
        setCategoryName("");
        setsubCategoryName("");
        setsubCategoryUrl("");
        setsubCategoryError("");
        setButton_press(false);
      }
    }
  };

  const input_lable_style = {
    color: "#1a1a1a",
    fontSize: "0.75rem",
    fontWeight: "800",
    marginBottom: "0.5vh",
    textTransform: "uppercase",
  };
  return (
    <>
      {contextHolder}
      <div className="add_page_main">
        <div className="add_hedaer_main_cnf">
          <div className="add_page_header">
            <h4>Add New Sub-Category</h4>
            <Link to="/admin/list-subcategory">
              <div className="bac_add_nav">
                <span>
                  <FaAngleLeft color="#333333" />
                </span>
                <h6>sub-Category List</h6>
              </div>
            </Link>
          </div>
        </div>
        <div className="add_input_box_main">
          <div className="add_page">
            <div className="input_container">
              
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Select Category <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-select"
                  select
                  variant="outlined"
                  size="small"
                  className="input_container"
                  defaultValue=""
                  error={
                    categoryName === "" && button_press === true ? true : false
                  }
                  helperText={
                    categoryName === "" && button_press === true
                      ? "Select category"
                      : ""
                  }
                  InputProps={{
                    style:
                      categoryName === "" && button_press === true
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  displayEmpty
                  // renderValue={
                  //   categoryName !== "" ? undefined : () => "Select Category"
                  // }
                >
                  {category_all.map((data, index) => (
                    <MenuItem key={index} value={data.name}>
                      {data.name}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Name
                </InputLabel>
                <TextField
                  id="custom-input"
                  placeholder="Enter Name"
                  variant="outlined"
                  error={subcategoryError !== "" ? true : false}
                  helperText={subcategoryError}
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  onChange={(e) => check_subcategory_url(e)}
                  value={subcategoryName}
                  InputProps={{
                    style:
                      subcategoryError !== ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Image
                </InputLabel>
                {!desktopImage ? (
                  <>
                    <div
                      className={
                        desktopImage === "" && button_press === true
                          ? "imageref_box image_error_input"
                          : "imageref_box"
                      }
                      onClick={handleImageClick}
                    >
                      <TbPhotoPlus size={28} color="#999999" />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="imageref_box" onClick={handleImageClick}>
                      <img src={desktopImage} alt="img" />
                    </div>
                  </>
                )}

                <span className="sub_text_title">Aspect Ratio - 4:3</span>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </div>

              <div className="submit_btn_container">
                <Button
                  className="confirm_btn sub_padding"
                  onClick={() => submitPress()}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSubcategory;
